import { supabase } from "@/integrations/supabase/client";
import { setBlogSlugs } from "@/i18n/locales";

/** Load German blog slugs (blog_post_translations.slug) into the URL mapper. */
let started = false;
export function loadBlogSlugs() {
  if (started) return;
  started = true;
  (async () => {
    const { data } = await (supabase as any)
      .from("blog_post_translations")
      .select("slug, locale, blog_posts!inner(slug, status)")
      .eq("locale", "de")
      .not("slug", "is", null)
      .eq("blog_posts.status", "published");
    const map: Record<string, string> = {};
    for (const r of (data ?? []) as Array<{ slug: string; blog_posts: { slug: string } }>) {
      if (r.slug && r.blog_posts?.slug) map[r.blog_posts.slug] = r.slug;
    }
    setBlogSlugs("de", map);
    (window as unknown as { __blogSlugsReady?: boolean }).__blogSlugsReady = true;
  })().catch(() => {
    started = false;
  });
}
